const ProgressBar = ({ total, current }) => {
  const percent = (current / total) * 100;

  return (
    <div style={{ height: 6, background: '#E5E7EB', borderRadius: 4 }}>
      <div
        style={{
          width: `${percent}%`,
          height: '100%',
          background: '#1d7789',
          borderRadius: 4,
          transition: 'width 0.3s ease',
        }}
      />
    </div>
  );
};
export default ProgressBar;
